import {resolveApiBaseURL} from '@infrastructure';
import {useImageWithBaseUrl} from '@lib/logic';

export const useImage = (token: string, endpoint: string | null, apiVersion: '1.0' | '2.0' = '1.0') =>
  useImageWithBaseUrl(resolveApiBaseURL(), token, endpoint, apiVersion);
